import * as React from 'react';
import { Element as ReactScrollElement } from 'react-scroll';

import { IContentProps } from './content.container';

import FAQ from '../faq';
import StepsDescription from '../steps-description';
import GameLogo from 'components/game-logo';
import { SUB_CONTENT_SCROLL_ELEMENT } from 'components/content/content.constants';

import './content.styles.less';

export const Content = (props: IContentProps): JSX.Element => {
    const renderLogo = (): JSX.Element | null  => {
        return props.showGameLogo ? <GameLogo /> : null;
    };
    return (
        <div className="sitegen-content-wrapper">
            <div className="sitegen-fr-top-section">
                {renderLogo()}
                <ReactScrollElement
                    className="sitegen-fr-top-section__inner"
                    name={SUB_CONTENT_SCROLL_ELEMENT}
                >
                    {props.children}
                </ReactScrollElement>
            </div>
            <div className="sitegen-fr-static-section">
                <StepsDescription />
                <FAQ />
            </div>
        </div>
    );
};

export default Content;
